import {useCallback, useEffect, useState} from 'react';
import {SIMPLE_DIALOG_WRAPPER_ID} from '../dialog/constants';

export function useSimpleDialogIsOpen() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const getSimpleDialogWrapper = useCallback(() => {
    return document.getElementById(SIMPLE_DIALOG_WRAPPER_ID);
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const simpleDialogWrapper = getSimpleDialogWrapper();
      setIsOpen(!!simpleDialogWrapper);
    });

    // 자식 요소 중 dialog_wrapper의 존재 여부만 감시합니다.
    observer.observe(document.body, {
      childList: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [getSimpleDialogWrapper]);

  return isOpen;
}
